/* eslint-disable */
import { IHttpClient } from '../api';
import { Walk } from "@/domain/walk";
import { AppConfig } from "@/utils/enums";

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export interface WalkResponse {
    walks: Walk[];
}

export const WalkApi = (http: IHttpClient) => ({
    fetchAllWalks: () =>
        http.get<WalkResponse>(apiUrl + AppConfig.API_WALKS_URL)
            .then(response => ({
            walks: response.data
        })),
    fetchActiveWalks: () =>
        http.get<WalkResponse>(apiUrl + AppConfig.API_WALKS_URL + '/active')
            .then(response => ({
                walks: response.data
            })),
    saveNewWalk: (walk: Walk) =>
        http.post(apiUrl + AppConfig.API_WALKS_URL, walk)
            .then(data => {
                return data;
            })
            .catch(error => {
                return error;
            }),
    finishWalk: (walk: Walk) =>
        http.put<Walk>(apiUrl + AppConfig.API_WALKS_URL + '/finish', walk)
            .then(data => {
                return data;
            })
            .catch(error => {
                return error;
            }),
    updateWalk: (walk: Walk) =>
        http.put<Walk>(apiUrl + AppConfig.API_WALKS_URL, walk)
            .then(data => {
                return data;
            })
            .catch(error => {
                return error;
            }),
    getWalkDetails: (walkId: number) =>
        http.get<Walk>(apiUrl + AppConfig.API_WALKS_URL + '/' + walkId)
            .then(walkDetails => {
                return walkDetails;
            })
            .catch(error => {
                return error;
            })
});
